module.exports = __webpack_public_path__ + "static/media/plus1.e0a8dfbd.png";